import { IFilter } from "@saleor/components/Filter";
import { FilterOpts } from "@saleor/types";
import { SmopStatusEnum } from "@saleor/types/globalTypes";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import { createOptionsField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";
export enum TenantFilterKeys {
  brand = "brand",
  status = "status"
}

export interface StoreListUrlFiltersOpts {
  status: FilterOpts<SmopStatusEnum>;
}

const messages = defineMessages({
  active: {
    defaultMessage: "Active",
    description: "Active Mall"
  },
  deleted: {
    defaultMessage: "Deleted",
    description: "Delete Mall"
  },
  inactive: {
    defaultMessage: "Inactive",
    description: "Deactivated Mall"
  },
  status: {
    defaultMessage: "Status",
    description: "Mall Status"
  }
});

export function createFilterStructure(
  user: SmopUserTypeCode,
  intl: IntlShape,
  opts: StoreListUrlFiltersOpts
): IFilter<TenantFilterKeys> {
  return [
    {
      ...createOptionsField(
        TenantFilterKeys.status,
        intl.formatMessage(messages.status),
        [opts.status.value],
        false,
        user !== SmopUserTypeCode.SELLER_MASTER
          ? [
              {
                label: intl.formatMessage(messages.active),
                value: SmopStatusEnum.ACT
              },
              {
                label: intl.formatMessage(messages.inactive),
                value: SmopStatusEnum.INA
              },
              {
                label: intl.formatMessage(messages.deleted),
                value: SmopStatusEnum.DEL
              }
            ]
          : [
              {
                label: intl.formatMessage(messages.active),
                value: SmopStatusEnum.ACT
              },
              {
                label: intl.formatMessage(messages.inactive),
                value: SmopStatusEnum.INA
              }
            ]
      ),
      active: opts.status.active
    }
  ];
}
